const Index = () => {
  // Let _app redirect you to the right page
  return null;
};

export default Index;
